import { TZDateMini } from '@date-fns/tz';
import { setHours } from 'date-fns';
import { inTimeZoneWithSameFields, timeZone } from 'src/utils/date-time-format';

export function shiftBerlinZoneToTsoDate(isoString: string, tsoZone = 'UTC') {
  return inTimeZoneWithSameFields(new TZDateMini(isoString, timeZone), tsoZone);
}

export function shiftBerlinZoneToTso(isoString: string, tsoZone = 'UTC') {
  return shiftBerlinZoneToTsoDate(isoString, tsoZone).toISOString();
}

function shiftTsoZoneToBerlinDate(isoString: string, tsoZone = 'UTC') {
  return inTimeZoneWithSameFields(new TZDateMini(isoString, tsoZone), timeZone);
}

export function shiftTsoZoneToBerlin(isoString: string, tsoZone = 'UTC') {
  return shiftTsoZoneToBerlinDate(isoString, tsoZone).toISOString();
}

export function setBerlinZoneHours(isoString: string, hours: number) {
  return setHours(new TZDateMini(isoString, timeZone), hours).toISOString();
}
